import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CircleDollarSign, DollarSign, Users, Rocket } from "lucide-react";
const TokenomicsSection = () => {
  return <section id="tokenomics" className="py-24 bg-black relative">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold mb-16 text-center">
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-400 to-orange-600">
            Whale of a Scheme
          </span>
        </h2>

        <div className="max-w-4xl mx-auto">
          {/* Blueprint style background */}
          <div className="relative bg-blue-900/10 backdrop-blur-sm rounded-lg p-8 mb-8">
            <div className="absolute inset-0 bg-black"></div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 relative z-10">
              <div className="flex flex-col items-center text-center p-6 bg-black/40 backdrop-blur-sm rounded-lg border border-white/10 shadow-lg">
                <CircleDollarSign size={48} className="mb-4 text-orange-500" />
                <h3 className="text-2xl font-bold mb-2">Max Supply</h3>
                <p className="text-4xl font-mono text-orange-400">210,000,000</p>
                <p className="text-gray-400 mt-2">$POP</p>
              </div>

              <div className="flex flex-col items-center text-center p-6 bg-black/40 backdrop-blur-sm rounded-lg border border-white/10 shadow-lg">
                <Rocket size={48} className="mb-4 text-orange-500" />
                <h3 className="text-2xl font-bold mb-2">Launch Date</h3>
                <p className="text-4xl font-mono text-orange-400">05.05.2025</p>
                <p className="text-gray-400 mt-2">Mark your calendar</p>
              </div>
            </div>

            <h3 className="text-2xl font-bold mt-12 mb-6 text-center text-white">Tax Breakdown</h3>
            <p className="text-center mb-8 text-gray-400">(on every trade)</p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="p-4 bg-black/40 backdrop-blur-sm rounded-lg border border-white/10 text-center">
                <h4 className="text-xl font-bold text-orange-400 mb-2">8%</h4>
                <p className="font-medium">Growth</p>
                <p className="text-sm text-gray-400">popcorn for the sea-soned</p>
              </div>

              <div className="p-4 bg-black/40 backdrop-blur-sm rounded-lg border border-white/10 text-center">
                <h4 className="text-xl font-bold text-orange-400 mb-2">2%</h4>
                <p className="font-medium">Ocean Outlaw Fund</p>
                <p className="text-sm text-gray-400">wildlife rescue</p>
              </div>

              <div className="p-4 bg-black/40 backdrop-blur-sm rounded-lg border border-white/10 text-center">
                <h4 className="text-xl font-bold text-orange-400 mb-2">2%</h4>
                <p className="font-medium">Liquidity</p>
                <p className="text-sm text-gray-400">deep-sea stability</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Decorative elements */}
      <div className="absolute top-1/2 left-0 w-72 h-72 bg-orange-500/5 rounded-full blur-3xl -z-10"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-blue-900/10 rounded-full blur-3xl -z-10"></div>
    </section>;
};
export default TokenomicsSection;